// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Welcome devs to Shosay')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

import { Application } from "@hotwired/stimulus"
import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"
import 'animate.css'

import Trix from "trix"
Trix.config.textAttributes.highlight = { tagName: "mark" }

addEventListener("trix-initialize", (e) => {
  var groupElement = e.target.toolbarElement.querySelector(".trix-button-group.trix-button-group--text-tools")

  groupElement.insertAdjacentHTML("beforeend", '<button type="button" class="trix-button trix-button--icon trix-button--icon-highlight" data-trix-attribute="highlight" data-trix-key="y" title="Highlight" tabindex="-1">high</button>')
  const element = document.querySelector("trix-editor");
  const actions = {
    decreaseNestingLevel: false,
    strike: false,
    increaseNestingLevel: false
  }
  element.editor.element.editorController.toolbarController.updateActions(actions);
})

import AnimateScrollController from "./../controllers/animate_scroll_controller"
import FormController from "./../controllers/form_controller"
import CapformPreviewController from "./../controllers/capform_preview_controller"
import ToastController from "./../controllers/toast_controller"
import SidebarController from "./../controllers/sidebar_controller"
import HomeDemoController from "./../controllers/home_demo_controller"

const application = Application.start()
application.register("animate-scroll", AnimateScrollController)
application.register("form", FormController)
application.register("capformpreview", CapformPreviewController)
application.register("toast", ToastController)
application.register("sidebar", SidebarController)
application.register("home-demo", HomeDemoController)

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import { Alert, Autosave, Dropdown, Tabs, Popover, Toggle } from "tailwindcss-stimulus-components"
application.register('alert', Alert)
application.register('autosave', Autosave)
application.register('dropdown', Dropdown)
application.register('popover', Popover)
application.register('tabs', Tabs)
